import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {FormBuilder,FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from "rxjs";
import {DatePipe} from "@angular/common";
import {SystemLicenseService} from "../../../services/system-license.service";
import {CustomerService} from "../../../../partner/services/customer.service";

@Component({
  selector: 'app-system-licence-add-edit',
  templateUrl: './system-license-add-edit.component.html',
  styleUrls: ['./system-license-add-edit.component.scss']
})
export class SystemLicenseAddEditComponent {

  systemLicenceForm: FormGroup;
  saving = false;

  customers: any[] = [];
  customerSelected: number | undefined;

  licenseKey = '';
  customer = '';
  startAt = '';
  endAt = '';
  
  public licensing = false;

  public data: any;
  id: number;

  isSubmitted = false;

  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private systemLicenseService: SystemLicenseService,
              private customerService: CustomerService,
              private translate: TranslateService,
              private toast: ToastrService,
              public route: Router,
			  public datePipe: DatePipe,
              public router: ActivatedRoute
  ) {

    this.systemLicenceForm = this.fb.group({
      licenseKey: ['', [Validators.required]],
      customer: ['', [Validators.required]],
      startAt: ['', [Validators.required]],
      endAt: ['', [Validators.required]],
	  status: 'generate',
	  isEnable: ''
    });

  }

  ngOnInit() {
	this.systemLicenceForm.get('isEnable')?.setValue('1');
    this.id = this.router.snapshot.params.id;
	
    this.systemLicenceForm.patchValue(this.data);
    if (this.id){
      this.systemLicenseService.get(this.id)
          .pipe(first())
          .subscribe(x => {
            console.log(x);
            this.systemLicenceForm.patchValue(x);
            this.licenseKey = x.licenseKey;
            this.customer = x.customer ? x.customer.name : '';
			
            //this.startAt = x.startAt;
			const startAt = this.datePipe.transform(x.startAt, 'yyyy-MM-dd');
            this.systemLicenceForm.get('startAt')?.setValue(startAt);
			
            //this.endAt = x.endAt;
			const endAt = this.datePipe.transform(x.endAt, 'yyyy-MM-dd');
            this.systemLicenceForm.get('endAt')?.setValue(endAt);
			
			this.systemLicenceForm.get('isEnable')?.setValue(x.isEnable ? '1' : '0');
          } );
    }
    this.findCustomers()
  }

  get fc(): any {
    return this.systemLicenceForm.controls;
  }

  generateLicenseKey(): void {
	this.licensing = true;
    this.systemLicenseService.generate().subscribe({
        next: (response) => {
          this.systemLicenceForm.get('licenseKey')?.setValue(response['hydra:member']);
		  this.licensing = false;
        },
        error: (err) => {
          console.error('Erreur lors de la génération de la clé', err);
		  this.licensing = false;
        }
    });
  }

  onFormSubmit(): any {
    this.isSubmitted = true;
    if (this.systemLicenceForm.valid) {
      this.saving = true;
      if (this.id) {
		this.systemLicenceForm.get('isEnable')?.setValue(this.systemLicenceForm.get('isEnable')?.value === '1');
        this.systemLicenseService.put(this.id, this.systemLicenceForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('system licence') + ' ' + this.translate.instant('edited') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.route.navigate(['/security/system-license']);
            this.systemLicenceForm.reset();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) => {
            console.log(err)
            const errors: any[] = err.violations;

			if(err.violations){
				errors.forEach((v) => {
				  this.saving = false;

				  if (v.propertyPath === 'licenseKey') {
					this.systemLicenceForm.get('licenseKey')?.setErrors({serverError: v.message});
				  }

				});
			}else{
				this.saving = false;
			}
            
          }
        });
      } else {
		this.systemLicenceForm.get('isEnable')?.setValue(this.systemLicenceForm.get('isEnable')?.value === '1');
        this.systemLicenseService.post(this.systemLicenceForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('system licence') + ' ' + this.translate.instant('created') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.systemLicenceForm.reset();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) => {
            console.log(err)
            const errors: any[] = err.violations;
            this.saving = false;
            if(err.violations){
              errors.forEach((v) => {
                this.saving = false;
                if (v.propertyPath === 'licenseKey') {
                  this.systemLicenceForm.get('licenseKey')?.setErrors({serverError: v.message});
                }
              });
            }

          }
        });
      }

    }
  }

  findCustomers(): any{
    this.customerService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.customers = data['hydra:member'];
          this.customers = this.customers.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => {
          console.log(error)
        },
    );
  }


}
